import { useField } from "formik";
import { InputText } from "primereact/inputtext";
import { forwardRef } from "react";

import { CustomInputProps } from "./types";

export const SimpleTextField = forwardRef<HTMLInputElement, CustomInputProps>(
  ({ id, label, ...props }: CustomInputProps, ref) => {
    const [field, meta] = useField(props.name);

    return (
      <span className="gap-2 flex flex-column" id={id}>
        <InputText ref={ref} placeholder={label} {...props} {...field} />
        {meta.error && meta.touched && (
          <small className="text-red-500 text-sm ml-1">{meta.error}</small>
        )}
      </span>
    );
  },
);
